import styled from 'styled-components';

const BottomText = styled.div`
  align-items: center;
  display: flex;
  margin: ${({ margin }) => margin};
  max-width: 500px;
  text-align: center;
  justify-content: center;
  align-items: baseline;
  height: 15px;
  color: #fff;
`;

export default BottomText;
